import React, { useState } from "react";
import configData from "../../../config.json";
import motivationlist from "../Motivationlist";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import axios from "axios";

let testdata;
function Dailymotivation({ setExpand, setSelected }) {
  const [testinfo, settestinfo] = useState(false);
  const [patientdata, setPatientdata] = useState([]);

  function backtotestlist() {
    settestinfo(false);
  }
  useEffect(() => {
    getsinglepatientdetail();
  }, []);
  const getsinglepatientdetail = async () => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/users/get_single_user`,
        {
          userId: localStorage.getItem("userId"),
        },
      );

      if (response.data.success) {
        console.log("get single user successfully", response.data.user);
        setPatientdata(response.data.user);
        console.log("<><><><>", patientdata);
      } else {
        console.error(
          "Error adding medical registration details:",
          response.data.error,
        );
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });
  const isMobileScreen = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const back = {
    fontWeight: "600",
    fontSize: "12px",
    color: "#004AAD",
    cursor: "pointer",
  };
  const heading = {
    color: "#F0588B",
    fontWeight: "600",
    fontSize: isMobileScreen ? "20px" : isTabScreen ? "22px" : "24px",
    paddingTop: "10px",
  };
  const para = {
    paddingBottom: "66px",
    fontFamily: "poppins",
    fontSize: "14px",
    fontWeight: "400",
    color: "#333333",
  };
  const parahead = {
    paddingBottom: "10px",
    marginTop: "30px",
    fontFamily: "poppins",
    fontSize: "16px",
    fontWeight: "600",
    color: "#333333",
  };
  const testimg = {
    width: "585px",
    height: "400px",
    margin: "0px auto",
    paddingBottom: "100px",
  };
  const wrapper = {
    marginLeft: isMobileScreen ? "10px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobileScreen ? "10px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobileScreen ? "14px" : isTabScreen ? "20px" : "50px",
    paddingRight: isMobileScreen ? "14px" : "20px",
    paddingBottom: isMobileScreen ? "24px" : "50px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: isMobileScreen ? "20px" : "30px",
    marginBottom: isMobileScreen ? "20px" : "50px",
    maxHeight: "100vh",
    overflowY: "auto",
  };
  const motivationCard = {
    marginTop: "10px",
    background: "linear-gradient(135deg, #FFF5F8 0%, #FFFFFF 100%)",
    border: "1px solid #FDE2EB",
    borderRadius: "12px",
    padding: isMobileScreen ? "14px" : "20px",
  };
  const motivationText = {
    color: "#333333",
    fontSize: isMobileScreen ? "15px" : "17px",
    lineHeight: isMobileScreen ? "26px" : "30px",
    fontWeight: "500",
    marginBottom: 0,
  };
  const dayPill = {
    display: "inline-block",
    background: "#F0588B",
    color: "#FFFFFF",
    borderRadius: "999px",
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "10px",
  };
  const todaysMotivation = motivationlist.find(
    (i) => patientdata.pregnancy_days === i.pregnancy_day,
  );

  return (
    <div style={wrapper}>
      <div>
        {testinfo === true ? (
          <>
            <div style={back} onClick={() => backtotestlist()}>
              BACK
            </div>
            <div style={heading}>{testdata.testname}</div>
            <div style={parahead}>{testdata.infohead}</div>
            <div style={para}>{testdata.info}</div>
            <div className="container">
              <div className="row">
                <div className="col-8">
                  <div style={parahead}>{testdata.infohead}</div>
                  <div style={para}>{testdata.info}</div>
                </div>
                <div className="col-4">
                  {/* <div className="w-75"> */}
                  <img src={testdata.img} className="img-fluid" alt="..."></img>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              style={back}
              onClick={() => {
                setSelected(false);
                setExpand(true);
              }}
            >
              BACK
            </div>
            <div style={heading}>Daily motivation</div>
            {/* <div className="container">
              <div className="row" style={innerrow}>
                {meditationlist.map((r) => (
                  <div
                    className="col-md-4 col-lg-3"
                    style={innercol}
                    onClick={() => handletestinfo(r)}
                  >
                    <div className="card text-white" style={{ border: "none" }}>
                      <img src={r.img} className="card-img" alt="..."></img>
                      <div className="card-img-overlay d-flex justify-content-center align-items-center">
                        <div style={testnm}>
                          <div className="card-title text-center">
                            {r.testname}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
            <div className="py-4">
              <div style={motivationCard}>
                <div style={dayPill}>Day {patientdata.pregnancy_days || "-"}</div>
                <p style={motivationText}>
                  {todaysMotivation?.info ||
                    "Take a deep breath, stay positive, and trust your body. You are doing great."}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default Dailymotivation;
